import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import React, { useEffect, useState } from "react";
import { openSuccessDialog } from "../../../../utils/ui-components/pop-ups/SuccessDialog";
import EmptyResult from "../../../../utils/ui-components/EmptyResult";
import Spinner from "../../../../utils/ui-components/Spinner";
// import TablePaginationActions from "@mui/material/TablePagination/TablePaginationActions";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { gridSpacing } from "../../../../store/constants";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Select from "../../../../utils/ui-components/FormsUI/Select";
import TextFieldFormik from "../../../../utils/ui-components/FormsUI/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { closeConfirmDialog, openConfirmDialog } from "../../../../utils/ui-components/pop-ups/ConfirmDialog";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainCard from "../../../../utils/ui-components/MainCard";
import { RateCardService } from "../../../../assets/_services/rate-card-service";
import { ChannelService } from "../../../../assets/_services/channel-service";
import { useDispatch } from "react-redux";
import { SET_BREADCRUMBS } from "../../../../redux/actions/actions";
import { useTheme } from "@mui/material/styles";
import { currencyFormat } from "../../../../utils/utils";
import TextFieldWrapper from "../../../../utils/ui-components/FormsUI/TextField";
import MultipleSelectCheckmarksWrapper from "../../../../utils/ui-components/FormsUI/MultipleSelectCheckmarks";

function AddEditRewardRateCard() {
  const INITIAL_FORM_STATE = {
    rateCardName: "",
    channels: [],
    operatorPrice: [],
  };
  const params = useParams();
  const dispatch = useDispatch();
  const theme: any = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("lg"));
  const [initialState, setInitialState] = useState(INITIAL_FORM_STATE);

  const id = params?.id || 0;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [channels, setChannels] = useState<{ value: number | string; label: string; rewardValue: number | string }[]>([]);
  const [rateCardName, setRateCardName] = useState("");
  const [isEdit, setIsEdit] = useState(Number(id) === 0 ? true : false);

  useEffect(() => {
    if (!matchDownSM) {
      dispatch({
        type: SET_BREADCRUMBS,
        payload: [
          { name: "Home", path: "/Dashboard", bold: true },
          { name: `Data Rate Card`, path: "/config/rate-card", state: state, bold: true },
          { name: Number(id) === 0 ? "Create" : `Rate Card ( id : ${id} )`, path: null, bold: false },
        ],
      });
    }
    ChannelService.getDataChannelListWithoutPagination().then((response) => {
      if (response.isSuccess) {
        setChannels(response.data.data.map((item: any) => ({ value: item.id, label: item.channelName, rewardValue: item.rewardValue })));
      }
    });
    if (Number(id) !== 0) {
      fetchRateCardData();
    } else {
      setIsLoading(false);
    }
  }, []);

  const fetchRateCardData = () => {
    setIsLoading(true);
    const formData = {
      rateCardId: id,
    };
    RateCardService.getDigitalRateCardDetilsById(formData).then((response) => {
      if (response.isSuccess) {
        setRateCardName(response?.data?.data?.rateCardName);
        setItems(response?.data?.data?.dataChannelDetails);
        setInitialState({
          rateCardName: response?.data?.data?.rateCardName,
          channels: response?.data?.data?.dataChannelDetails?.map((item: any) => ({ value: item?.channelId })),
          operatorPrice: response.data?.data?.dataChannelDetails.map((item: any) => ({
            channelName: item.channelName,
            channelId: item.channelId,
            rewardValue: item.rewardValue,
            base_price: item.operatorCosts.base_price,
            profit_margin: item.operatorCosts.profit_margin,
          })),
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  const createRateCard = (values: any, setSubmitting: (isSubmitting: boolean) => void) => {
    setIsLoading(true);
    let formData = {
      rateCardName: values.rateCardName,
      channelOperatorCost: values.operatorPrice.reduce((acc: any, item: any) => {
        acc[item.channelId] = { base_price: item.base_price, profit_margin: item.profit_margin };
        return acc;
      }, {}),
    };
    RateCardService.createDigitalRateCard(formData).then((response) => {
      setSubmitting(false);
      if (response.isSuccess) {
        openSuccessDialog("Success", response.data.comment);
        setIsLoading(false);
        navigate("/config/rate-card", { state: state });
      } else {
        setSubmitting(false);
        setIsLoading(false);
      }
    });
  };

  const updateRateCard = (values: any, setSubmitting: (isSubmitting: boolean) => void) => {
    setIsLoading(true);
    let formData = {
      rateCardId: id,
      rateCardName: values.rateCardName,
      channelOperatorCost: values.operatorPrice.reduce((acc: any, item: any) => {
        acc[item.channelId] = { base_price: item.base_price, profit_margin: item.profit_margin };
        return acc;
      }, {}),
    };
    console.log(formData);
    RateCardService.updateDigitalRateCard(formData).then((response) => {
      setSubmitting(false);
      if (response.isSuccess) {
        openSuccessDialog("Success", response.data.comment);
        navigate("/config/rate-card", { state: state });
        setIsLoading(false);
      } else {
        setSubmitting(false);
        setIsLoading(false);
      }
    });
  };

  const FORM_VALIDATION = Yup.object().shape({
    rateCardName: Yup.string().required("Rate card name required").trim("Enter valid name"),
    channels: Yup.array()
      .of(Yup.object().shape({ value: Yup.string(), label: Yup.string() }))
      .required("Please select the channel")
      .min(1, "Please select the channel"),
    operatorPrice: Yup.array()
      .required("Please select the channel")
      .of(
        Yup.object().shape({
          channelName: Yup.string().notRequired(),
          channelId: Yup.string().notRequired(),
          base_price: Yup.number()
            .typeError("Allowed numbers only")
            .required("Please enter rate")
            .min(0, "Rate must be greater than or equal to 0")
            .test(
              "maxDigitsAfterDecimal",
              "number field must have 2 digits after decimal or less",
              (number: any) => !number || /^\d+(\.\d{1,2})?$/.test(number),
            ),
          profit_margin: Yup.number()
            .typeError("Allowed numbers only")
            .required("Please enter rate")
            .min(0, "Rate must be greater than or equal to 0")
            .test(
              "maxDigitsAfterDecimal",
              "number field must have 2 digits after decimal or less",
              (number: any) => !number || /^\d+(\.\d{1,2})?$/.test(number),
            ),
        }),
      )
      .min(1, "At least one channel is required"),
  });

  return (
    <Grid container spacing={5} justifyContent={"center"}>
      <Grid item lg={11} md={12} xs={12}>
        <Typography sx={{ ...theme.typography.pageheader }}>{Number(id) === 0 ? "Create" : "Update"} Data Reward Rate Card</Typography>
      </Grid>
      {!isLoading && (
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Formik
            initialValues={initialState}
            validationSchema={FORM_VALIDATION}
            // enableReinitialize
            onSubmit={(values: any, { resetForm, setSubmitting }) => {
              if (Number(id) !== 0) {
                updateRateCard(values, setSubmitting);
              } else {
                createRateCard(values, setSubmitting);
              }
            }}
          >
            {({ values, dirty, isSubmitting, isValid, setFieldValue, setSubmitting, resetForm }) => (
              <Form>
                <Grid container spacing={gridSpacing}>
                  <Grid item xs={12}>
                    <MainCard>
                      <Grid container rowSpacing={1} columnSpacing={1}>
                        <Grid item xs={4}>
                          <TextFieldWrapper label="Rate Card Name" name={"rateCardName"} required fullWidth />
                        </Grid>
                        <Grid item xs={9}>
                          <MultipleSelectCheckmarksWrapper name="channels" label="Select Channels" options={channels} />
                        </Grid>
                        <Grid item xs={1.5}>
                          <Button
                            color="primary"
                            variant="contained"
                            sx={{ ...theme.typography.customInput }}
                            type="button"
                            onClick={() => {
                              let newOperatorPrice: any[] = [];

                              values.channels.map((item: any) => {
                                const index = values.operatorPrice.findIndex((op: any) => op.channelId === item.value);
                                if (index === -1) {
                                  newOperatorPrice = [
                                    ...newOperatorPrice,
                                    {
                                      channelName: channels.find((channel: any) => channel.value === item.value)?.label,
                                      channelId: item.value,
                                      rewardValue: channels.find((channel: any) => channel.value === item.value)?.rewardValue,
                                      base_price: 0,
                                      profit_margin: 0,
                                    },
                                  ];
                                } else {
                                  newOperatorPrice = [...newOperatorPrice, values.operatorPrice[index]];
                                }
                              });

                              setFieldValue("operatorPrice", newOperatorPrice);
                            }}
                          >
                            Add Channels
                          </Button>
                        </Grid>
                        <Grid item xs={1.5}>
                          <Stack direction={"row"} justifyContent={"flex-end"}>
                            <Button
                              color="warning"
                              variant="contained"
                              sx={{ ...theme.typography.customInput }}
                              type="button"
                              onClick={() => {
                                openConfirmDialog("Reset Form", "Are you sure you want to reset ratecard", {}, () => {
                                  resetForm();
                                  closeConfirmDialog();
                                });
                              }}
                            >
                              Reset
                            </Button>
                          </Stack>
                        </Grid>
                        <Grid item xs={12}>
                          <TableContainer component={Paper}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell></TableCell>
                                  <TableCell>Data Channel</TableCell>
                                  <TableCell>Reward Value</TableCell>
                                  <TableCell>Base Price</TableCell>
                                  <TableCell>Profit Margin</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {values?.operatorPrice.length > 0 &&
                                  !isLoading &&
                                  values?.operatorPrice.map((item: any, index: number) => (
                                    <TableRow hover key={index}>
                                      <TableCell width={"50px"}>
                                        <Tooltip title="Remove Channel">
                                          <IconButton
                                            aria-label="view"
                                            color="primary"
                                            onClick={(e: any) => {
                                              openConfirmDialog("Delete", `Are you sure you want to remove this channel from rate card?`, {}, () => {
                                                let newChannels = values.channels.filter((channel: any) => channel.value !== item.channelId);
                                                let newOperatorPrice = values.operatorPrice.filter((op: any) => op.channelId !== item.channelId);
                                                setFieldValue("channels", newChannels);
                                                setFieldValue("operatorPrice", newOperatorPrice);

                                                closeConfirmDialog();
                                              });
                                            }}
                                          >
                                            <DeleteIcon fontSize="inherit" color="error" />
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                      <TableCell sx={{ minWidth: "200px" }}>
                                        <Typography variant="subtitle1">{item?.channelName || ""}</Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography>{item?.rewardValue || ""}</Typography>
                                      </TableCell>
                                      <TableCell>
                                        <TextFieldWrapper type="number" label="" name={`operatorPrice[${index}].base_price`} required fullWidth />
                                      </TableCell>
                                      <TableCell>
                                        <TextFieldWrapper type="number" label="" name={`operatorPrice[${index}].profit_margin`} required fullWidth />
                                      </TableCell>
                                    </TableRow>
                                  ))}
                              </TableBody>
                            </Table>

                            {!values.operatorPrice?.length && !isLoading ? (
                              <EmptyResult />
                            ) : isLoading ? (
                              <Box
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexDirection: "column",
                                  minHeight: "40vh",
                                }}
                              >
                                <Spinner />
                              </Box>
                            ) : null}
                          </TableContainer>
                        </Grid>
                        <Grid item xs={12}>
                          <Stack direction={"row"} justifyContent={"flex-end"}>
                            <Button
                              color="primary"
                              variant="contained"
                              disabled={!dirty || isSubmitting || !isValid}
                              sx={{ ...theme.typography.customInput }}
                              type="submit"
                            >
                              Save Ratecard
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                    </MainCard>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Grid>
      )}
    </Grid>
  );
}

export default AddEditRewardRateCard;
